import React from 'react';
import { useParams } from 'react-router-dom';
import { TicketApi } from '../../redux/api/TicketApi';
import Progress from './Progress';
import { ITicketProps } from '../../types/Ticket/ITicket';

import { Card, CardBody, CardHeader } from '@progress/kendo-react-layout';

interface GameplanDetailsProps {
    // Define your props her
}

const GameplanDetails: React.FC<GameplanDetailsProps> = (props) => {
    const { ticketId } = useParams();
    const { data: ticket } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();
    return (
        <Card>
            <CardHeader className='action-header flex-wrap' style={{ color: '#fff', background: userProfile?.Nav_Hex_Color }}>
                <div className='col-10'>
                    <img width={25} src='./images/Nav/gameplan.png' /> Gameplan
                </div>
                <div className='col-2 d-flex flex-grow align-items-end'>
                    {/* Daily or hourly view */}
                    {/* <DropDownList size='medium'
                            data={[{ text: 'Daily', value: 0 }, { text: 'Hourly', value: 1 }]}
                            textField="text"
                            dataItemKey="value"
                            value={view}
                            onChange={(e) => {
                                setView(e.target.value);
                                console.log('onChange', e.target.value)
                            }} /> */}
                </div>
            </CardHeader>
            <CardBody>
                <Progress {...ticket as ITicketProps} />
            </CardBody>
        </Card>
    );
};

export default GameplanDetails;